module.exports = __webpack_public_path__ + "static/media/airbnbminiicon.cf0db202.svg";